import { render, staticRenderFns } from "./TabAttachments.vue?vue&type=template&id=1af7b957"
import script from "./TabAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./TabAttachments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports